import { getBasSubjectList, getBasSubjectList2 } from '@/api/bas/basSubject'

const basSubject = {
  state: {
    basSubjectList: [],
    basSubjectListSCAndCK: [], // 供应链主体和央厨主体
  },
  actions: {
    getBasSubject({commit, state}) {
      if (state.basSubjectList.length === 0) {
        getBasSubjectList({
        }).then(res => {
          commit('setBasSubject', res.data)
        }).catch(err => {
          console.log(err)
        })
      }
    },
    resetBasSubject({commit, state}) {
      getBasSubjectList({
      }).then(res => {
        commit('setBasSubject', res.data)
      }).catch(err => {
        console.log(err)
      })
    },
    getBasSubjectSCAndCk({commit, state}) {
      if (state.basSubjectListSCAndCK.length === 0) {
        getBasSubjectList2({
          subjectTypes: ["SC", "CK"]
        }).then(res => {
          commit('setBasSubjectSCAndCk', res.data)
        }).catch(err => {
          console.log(err)
        })
      }
    },
    resetBasSubjectSCAndCk({commit, state}) {
      getBasSubjectList2({
        subjectTypes: ["SC", "CK"]
      }).then(res => {
        commit('setBasSubjectSCAndCk', res.data)
      }).catch(err => {
        console.log(err)
      })
    },
  },
  mutations: {
    setBasSubject: (state, data) => {
      state.basSubjectList = data
    },
    setBasSubjectSCAndCk: (state, data) => {
      state.basSubjectListSCAndCK = data
    }
  }
}

export default basSubject
